import React from "react";

const IconBox = ({ children, className, white, small, smallxss,smallxs, ...rest }) => {
  return (
    <div
      className={`IconBox center cursor-pointer  ${white
        ? "IconBox__white"
        : "IconBox__green"} ${small
        ? "IconBox__small"
        : smallxs ? "IconBox__small--xs" : smallxss ? "w-[40px] h-[40px]" : "IconBox__big"} ${className}`}
      {...rest}
      
    >
      {children}
    </div>
  );
};

export default IconBox;
